//上一步
export const PREVIOUS_SETP = 'PREVIOUS_SETP';
//下一步
export const NEXT_STEP = 'NEXT_STEP';
//完成
export const FINISH_SETP = 'FINISH_SETP';
//设置token
export const SET_TOKEN = 'SET_TOKEN';
//设置步骤信息
export const SET_SEPT_INFO ='SET_SEPT_INFO';


// WEBPACK FOOTER //
// ./src/store/data.js